import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const PageWrap = styled(Flex).attrs({
  column: true,
})`
  background-size: cover;
  overflow: auto;
  width: 100%;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  justify-content: center;
  align-items: center;
  margin: auto;
  padding-top: 55px;
  padding-bottom: 30px;

  img {
    max-width: 100%;
  }
`;

export const FormWrap = styled(Flex).attrs({
  column: true,
  spacing: 50,
})`
  color: #231F20;
  width: 90%;
  max-width: 510px;
  margin: 30px auto;
  border: 1px solid #B6B6B6;
  box-shadow: 0px 4px 10px 0px #00000040;
  border-radius: 5px;
  padding: 30px 25px;

  ul > li {
    color: #231F20;
    font-size: 1.36em;
  }

  hr {
    background-color: #000000;
  }

  img {
    max-width: 100%;
  }
`;

export const Header = styled.div`
  background-color: #343A3D;
  color: white;
  padding: 15px 0;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  z-index: 9;
`;

export const Dropdown = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  position: relative;
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const Trigger = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
}) <{ isOpen?: boolean }>`
  color: ${props => (props.isOpen ? '#fff' : '#a6a9aa')};
  height: 46px;
  cursor: pointer;
`;

export const Actions = styled.div`
  min-width: 160px;
  padding: 14px 0;
  margin-top: 6px;
  background-color: #343A3D;
  z-index: 999;
  box-sizing: border-box;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Action = styled(Flex).attrs({
  spacing: 10,
  padding: '0 15px',
})`
  color: #fff;
  font-size: 12px;
  height: 39px;
  line-height: 39px;
  cursor: pointer;

  &:hover span {
    opacity: 1;
  }
`;

export const ActionIcon = styled.span<{ icon: string }>`
  height: 22px;
  width: 20px;
  opacity: 0.65;
  position: relative;
  top: 7px;
  left: 7px;
  background-repeat: no-repeat;
  ${(props) => {
    switch (props.icon) {
      case 'payment':
        return `
          background-size: contain;
          background-position: center;
        `;
      case 'referral':
        return `
          background-size: 100% 100%;
        `;
      case 'signout':
        return `
          background-size: 14px;
          background-position: center;
        `;
      default:
        return `
          background-size: cover;
          background-position: left top;
        `;
    }
  }}
`;


export const SubmitButton = styled(Button).attrs({
  ghost: true,
  type: 'submit',
  appearance: 'primary',
})`
  color: #fff !important;
  font-size: 18px;
  height: auto;
  padding: 10px 25px;
  border: none;
  background: ${props => props.theme.colors.primaryBright} !important;
  border-radius: 5px;
  width: 100%;
  line-height: 24px;
`;

